/**
 * @ External Dependencies
 */
import React from 'react';
import { ReactSVG } from 'react-svg'

const IconSvgComponent = ({
	icon,
	additionalClass
}) => {
 	let classAddition = ''

 	if ( additionalClass !== undefined ) {
 		classAddition = additionalClass
 	} else {
 		classAddition = ''
 	}

	// Check if icon prop is provided
	if (!icon) {
		return <div className={`svg-icon ${classAddition}`}></div>;
	}

	// Check if icon is a React component (embedded SVG)
	if (typeof icon === 'function' || (icon && icon.$$typeof)) {
		const IconComponent = icon;
		return (
			<div className={`svg-icon ${classAddition}`}>
				<IconComponent />
			</div>
		);
	}

	// Otherwise, treat it as a string path and use ReactSVG
	return (
		<ReactSVG
			src={icon}
			className={`svg-icon ${classAddition}`}
			beforeInjection={(svg) => {
				// Ensure SVG has proper dimensions if missing
				if (!svg.getAttribute('width')) {
					svg.setAttribute('width', '24');
				}
				if (!svg.getAttribute('height')) {
					svg.setAttribute('height', '24');
				}
				// Ensure viewBox is set if missing
				if (!svg.getAttribute('viewBox') && svg.getAttribute('width') && svg.getAttribute('height')) {
					const width = svg.getAttribute('width').replace('px', '');
					const height = svg.getAttribute('height').replace('px', '');
					svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
				}
				// Preserve stroke properties on all elements with strokes
				const elementsWithStroke = svg.querySelectorAll('[stroke]');
				elementsWithStroke.forEach(el => {
					// Ensure stroke-width is set and visible
					if (!el.getAttribute('stroke-width')) {
						el.setAttribute('stroke-width', '1.4');
					}
					// Make sure stroke is not being overridden
					el.style.stroke = el.getAttribute('stroke') || '#FFFFFF';
					el.style.strokeWidth = el.getAttribute('stroke-width');
				});
				
				// Preserve fill properties on all elements with fills
				const elementsWithFill = svg.querySelectorAll('[fill]');
				elementsWithFill.forEach(el => {
					const fillValue = el.getAttribute('fill');
					// Only apply fill if it's not 'none'
					if (fillValue && fillValue !== 'none') {
						el.style.fill = fillValue;
					}
				});
			}}
			fallback={() => <div className={`svg-icon ${classAddition}`}>Icon</div>}
			loading={() => <div className={`svg-icon ${classAddition}`}>...</div>}
		 />
	)
}

export default IconSvgComponent;
